import { WebApi } from '../../services/WebApi'

const state = () => ({
  loadingCheckoutSession: false,
  checkoutSession: null
})

const mutations = {
  setLoading (state, value) {
    state.loadingCheckoutSession = !!value
  },
  setCheckoutSession (state, checkoutSession) {
    state.checkoutSession = checkoutSession
  }
}

const actions = {
  updateCheckoutSession ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.put('ClientCheckoutSession', payload)
        .then(response => {
          commit('setCheckoutSession', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
